import styled from 'styled-components';

export const Style = styled.div`
  h4 {
    font-size: 18px;
    font-weight: 500;
    color: #555;
  }
  span {
    font-size: 14px;
    color: #40977f;
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 11px;
    margin-bottom: 8px;
  }

  input,
  textarea {
    width: 100%;
    padding: 10px 20px;
    border-radius: 5px;
    border: 1px solid #cecece;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 30px;
  }
  input::placeholder,
  textarea::placeholder {
    color: #cecece;
    font-weight: 400;
  }
  textarea {
    height: 80px;
  }

  .selectDateWrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 30px;
  }
  .dateSelect {
    flex: 1;
  }

  .navigateBtn {
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    padding: 4px 10px;
    color: #4dd2ae;
  }

  /* submitButton */
  .submitButton {
    width: 100%;
    text-align: center;
  }
  .submitButton.cancel {
    margin-top: 20px;
    padding: 11px 0;
    background: #fff;
    border: 1px solid #4dd2ae;
    color: #4dd2ae;
  }
`;
